import { addComponent, defineQuery, enterQuery, exitQuery, Not } from "bitecs";
import { AnimationComponent } from "../components/AnimationComponent";
import { MovementGoalComponent } from "../components/MovementGoalComponent";
import { TagPetComponent } from "../components/TagPetComponent";
import { TagTouchedComponent } from "../components/TagTouchedComponent";
import { TinyPetsWorld } from "../TinyPetsWorld";

export const createPetAnimationSystem = (
    world: TinyPetsWorld,
    config: {}
): {
    petAnimationSystem: (world: TinyPetsWorld) => TinyPetsWorld;
} => {
    const PET_ANIMATION_IDLE = 1;
    const PET_ANIMATION_TOUCHED = 7;
    const PET_ANIMATION_MOVING = 0;

    const entityQuery = defineQuery([
        TagPetComponent,
        AnimationComponent,
        Not(TagTouchedComponent),
    ]);
    const enteredQuery = enterQuery(entityQuery);

    const touchedQuery = defineQuery([
        TagPetComponent,
        AnimationComponent,
        TagTouchedComponent,
    ]);
    const touchedEnteredQuery = enterQuery(touchedQuery);
    const touchedExitedQuery = exitQuery(touchedQuery);

    const movementQuery = defineQuery([
        TagPetComponent,
        AnimationComponent,
        MovementGoalComponent,
    ]);
    const movementEnteredQuery = enterQuery(movementQuery);
    const movementExitedQuery = exitQuery(movementQuery);

    const animationsBefore: {
        [eid: number]: { key: number; timeScale: number };
    } = {};

    const getAnimationBefore = (eid: number) => {
        return animationsBefore[eid] !== undefined
            ? animationsBefore[eid]
            : { key: PET_ANIMATION_IDLE, timeScale: 1 };
    };

    return {
        petAnimationSystem: (world: TinyPetsWorld) => {
            enteredQuery(world).forEach((eid: number) => {
                addComponent(world, AnimationComponent, eid);

                AnimationComponent.key[eid] = PET_ANIMATION_IDLE;
                AnimationComponent.dirty[eid] = 1;
            });

            movementEnteredQuery(world).forEach((eid: number) => {
                animationsBefore[eid] = {
                    key: AnimationComponent.key[eid],
                    timeScale: AnimationComponent.timeScale[eid],
                };

                AnimationComponent.key[eid] = PET_ANIMATION_MOVING;
                AnimationComponent.dirty[eid] = 1;
                AnimationComponent.timeScale[eid] = 0.5;
            });
            movementExitedQuery(world).forEach((eid: number) => {
                AnimationComponent.key[eid] = getAnimationBefore(eid).key;
                AnimationComponent.timeScale[eid] =
                    getAnimationBefore(eid).timeScale;
                AnimationComponent.dirty[eid] = 1;
            });

            touchedEnteredQuery(world).forEach((eid: number) => {
                animationsBefore[eid] = {
                    key: AnimationComponent.key[eid],
                    timeScale: AnimationComponent.timeScale[eid],
                };

                AnimationComponent.key[eid] = PET_ANIMATION_TOUCHED;
                AnimationComponent.dirty[eid] = 1;
                AnimationComponent.timeScale[eid] = 1;
            });
            touchedExitedQuery(world).forEach((eid: number) => {
                AnimationComponent.key[eid] = getAnimationBefore(eid).key;
                AnimationComponent.timeScale[eid] =
                    getAnimationBefore(eid).timeScale;
                AnimationComponent.dirty[eid] = 1;
            });

            return world;
        },
    };
};
